import { render, staticRenderFns } from "./MultiChoiceCardsHeader.vue?vue&type=template&id=746892f4&"
import script from "./MultiChoiceCardsHeader.vue?vue&type=script&lang=ts&"
export * from "./MultiChoiceCardsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MultiChoiceCardsHeader.vue?vue&type=style&index=0&id=746892f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports